module.exports = __webpack_public_path__ + "media/video.29d17edd.mp4";